import { PlusOutlined } from '@ant-design/icons';
import { L } from '@lib';
import { Button, Col, Row } from 'antd';
import React from 'react';

interface IProps {
  style?: React.CSSProperties;
  hideIcon?: boolean;
  icon?: React.ReactElement;
  span?: number | undefined;
  title?: string | undefined;
  disabled?: boolean | undefined;
  onClick?: React.MouseEventHandler<HTMLElement> | undefined;
}

export const DashedButton: React.FC<IProps> = ({
  style,
  icon = <PlusOutlined />,
  span = 24,
  title = '',
  hideIcon = false,
  disabled = false,
  onClick,
}) => {
  return (
    <Row>
      <Col span={span}>
        <Button
          onClick={onClick}
          block
          icon={!hideIcon && icon}
          type="dashed"
          disabled={disabled}
          style={style}
        >
          {L(title)}
        </Button>
      </Col>
    </Row>
  );
};
